import React, { useState } from 'react';
import Layout from "../components/App/Layout";
import Navbar from "../components/App/Navbar";
import PageBanner from '../components/Common/PageBanner';
import Footer from "../components/App/Footer";
import SEO from "../components/App/SEO";
import application_banner from '../assets/images/application_banner.png';
import ai_banner3 from '../assets/images/ai_banner3.jpg';
import ai_banner2 from '../assets/images/ai-banner2.jpg';
import wf_banner3 from '../assets/images/wf_banner3.png';
import service_ap from '../assets/images/service_ap.png';
import service_ap2 from '../assets/images/service_ap2.png';
import service_ap3 from '../assets/images/service_ap3.png';
import app_1 from '../assets/images/app_1.png';
import app_2 from '../assets/images/app_2.png';
import Chargam from '../assets/images/Chargam.png';
import Alter_Resources from '../assets/images/Alter_Resources.png';
import Travel_Hospitality from '../assets/images/Travel_Hospitality.png';
// Add these imports at the top with other image imports
import step1_icon from '../assets/images/step1.png';
import step2_icon from '../assets/images/step2.png';
import step3_icon from '../assets/images/step3.png';
import step4_icon from '../assets/images/step4.png';
import step5_icon from '../assets/images/step5.png';
import Smart_Retail from "../assets/images/Smart_Retail.png"
import Smart_Sensors from "../assets/images/Smart_Sensors.png"
import Education_eLearning from "../assets/images/Education_eLearning.png"
import Agricultural_IoT from "../assets/images/Agricultural_IoT.png"
import Environmental_Monitoring from "../assets/images/Environmental_Monitoring.png"
import Healthcare_IoT from "../assets/images/Healthcare_IoT.png"
import Industrial_IoT from "../assets/images/Industrial_IoT.png"
import On_Demand_Service from "../assets/images/On_Demand_Service.png"
import Smart_Cities from "../assets/images/Smart_Cities.png"
import Smart_Energy from "../assets/images/Smart_Energy.png"
import Smart_Home from "../assets/images/Smart_Home.png"
import Swal from 'sweetalert2';
import consistent from '../assets/images/consistent.png';
import phonecall from '../assets/images/phonecall.png';
import FunfactComponent from "../components/DynamicPages/FunfactComponent"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
const sendEmail = async (e) => {
  e.preventDefault()
  // alert('sent successfully');

  const messageBody = `

  Hi,
  
  Name: ${e.target.elements.name.value}
  Phone No: ${e.target.elements.email.value}
  Message: ${e.target.elements.message.value}
  technology:${e.target.elements.technology.value}
  `
  console.log(messageBody);
  try {

    const response = await fetch('https://p8t29dandg.execute-api.ap-south-1.amazonaws.com/prod', {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "no-cors", // no-cors, cors, *same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: e.target.elements.email.value, messageBody },), // body data type must match "Content-Type" header
    }).then(() => Swal.fire(
      'Mail Sent Successfully!',

    )
    )
    window.location.reload(false);
    ;
    // const json = await response.json()

  } catch (error) {
    console.log(error);
  }
}
const services = [
  {
    title: "Chargam",
    text: "Chargam is a feature-packed app designed to simplify and enhance the way you manage and track your daily tasks and activities. With an intuitive interface, it allows you to set reminders, track goals, and stay organized throughout the day. Whether you're working on personal or professional tasks, Chargam helps you stay focused and productive.",
    topics: [
      "Ideal for anyone looking to boost their efficiency, Chargam ensures you never miss an important task.",
      "Easy task management with reminders and goal tracking.",
      "User-friendly interface for seamless navigation.",
      "Stay organized and increase productivity."
    ],
    icon: Chargam,
  },
  {
    title: "Alter Resources",
    text: <>Alter Resources is your go-to app for enhancing personal and professional growth through an extensive library of resources. Whether you're looking to improve your skills, expand your knowledge, or find tools for productivity, this app provides easy access to valuable content.<br /> <br />With categorized resources, curated lists, and regular updates, Alter Resources helps you stay ahead in your personal development journey.</>,
    topics: [
      "Increase sales without paid marketing",
      "Easy navigation with categorized content for quick access",
      "Regular updates with the latest resources to stay informed",
    ],
    icon: Alter_Resources,
  },
];

const products = [
  {
    title: "Types of Mobile Applications Developed",
    text: "",
    topics: [
      "<b>Native Apps:</b> Built specifically for a single operating system (iOS or Android) using platform-specific programming languages (Swift/Objective-C for iOS, Java/Kotlin for Android) and development tools. They offer the best performance and access to all device features.",
      "<b>Web Apps:</b> Responsive websites that function like apps on mobile devices but are accessed through a web browser. They are built using web technologies (HTML, CSS, JavaScript) and don't require installation.",
      "<b>Hybrid Apps:</b> Combine elements of native and web apps. They are built using web technologies but are wrapped in a native container, allowing them to be installed on devices and access some device features. Frameworks like Ionic and Cordova are used for hybrid development.",
      "<b>Progressive Web Apps (PWAs):</b> Web applications that offer a near-native app experience. They can be installed on the home screen, work offline, and receive push notifications, leveraging modern web technologies.",
      "<b>Cross-Platform Apps:</b>  Developed using frameworks like React Native, Flutter, and Xamarin, allowing a single codebase to be used for both iOS and Android platforms, saving time and resources. Built specifically for a single operating system (iOS or Android) using platform-specific programming languages (Swift/Objective-C for iOS, Java/Kotlin for Android) and development tools. They offer the best performance and access to all device features.",
    ],
    icon: app_1,
  },
  {
    title: "Benefits of Mobile Apps for Businesses",
    text: "Easy and Fast checkout or add cart | Boost your sales with Sarshta Sticky Add to cart app",
    topics: [
      "<b>Enhanced Customer Engagement:</b> Get features tailored precisely to your business needs, going beyond the limitations of off-the-shelf apps.",
      "<b>Improved Customer Experience:</b> Providing a convenient and user-friendly way for customers to interact with your brand.",
      "<b>Increased Sales and Conversions:</b> Streamlined purchasing processes and targeted promotions within the app.",
      "<b>Stronger Brand Loyalty:</b> Building a direct relationship with customers and offering exclusive value through the app.",
      "<b>Valuable Data and Insights:</b> Collecting user behavior data to understand customer preferences and improve offerings.",
      "<b>Competitive Advantage:</b> Standing out from competitors by offering innovative mobile solutions.",
      "<b>New Marketing Channel:</b> Utilizing the app for promotions, discounts, and building brand awareness.",
      "<b>Streamlined Business Operations:</b> Utilizing the app for promotions, discounts, and building brand awareness.",
      "<b>Offline Access:</b> : Providing access to certain features and content even without an internet connection (for some app types).",
    ],
    icon: app_2,
  },
];


const industries = [
  {
    title: "Smart Cities",
    icon: Smart_Cities,
  },
  {
    title: "Industrial IoT",
    icon: Industrial_IoT,
  },
  {
    title: "Smart Home",
    icon: Smart_Home,
  },
  {
    title: "Smart Retail",
    icon: Smart_Retail,
  },
  {
    title: "Agricultural IoT",
    icon: Agricultural_IoT,
  },
  {
    title: "On-Demand Service",
    icon: On_Demand_Service,
  },
  {
    title: "Smart Energy",
    icon: Smart_Energy,
  },
  {
    title: "Healthcare IoT",
    icon: Healthcare_IoT,
  },
  {
    title: "Environmental Monitoring",
    icon: Environmental_Monitoring,
  },
  {
    title: "Smart Sensors",
    icon: Smart_Sensors,
  },
  {
    title: "Education & eLearning",
    icon: Education_eLearning,
  },
  {
    title: "Travel & Hospitality",
    icon: Travel_Hospitality,
  },
];

// Update the executionSteps array to include icons
const executionSteps = [
  { text: "Project Initiation & Goal Definition", icon: step1_icon },
  { text: "Planning & Strategy", icon: step2_icon },
  { text: "Execution & Task Management", icon: step3_icon },
  { text: "Monitoring & Control", icon: step4_icon },
  { text: "Quality Assurance & Testing", icon: step5_icon },
  { text: "Closure & Review", icon: step5_icon }
];

const faqData = [
  {
    question: 'What AI development services do you offer?',
    answer: 'We offer services like natural language processing, machine learning model development, computer vision, AI consulting, and custom AI solution development.',
  },
  {
    question: 'How can AI benefit my business?',
    answer: 'AI can streamline operations, improve customer service, provide predictive analytics, and automate routine tasks, increasing overall efficiency and innovation.',
  },
  {
    question: 'What industries do you specialize in?',
    answer: 'We specialize in healthcare, finance, e-commerce, manufacturing, and logistics, among other industries.',
  },
];


const IotDevelopment = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <SEO
        title="Custom Application Development Services | Mobile & Web Apps | SrashtaSoft"
        description="Build scalable, high-performance mobile and web applications with SrashtaSoft. Our expert developers specialize in custom software, SaaS platforms, and enterprise solutions."
        canonical="https://srashtasoft.com/application-development/"
        isServicePage
        serviceName="Application Development Services"
        faqData={faqData}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section" style={{
        background: `url(${application_banner}) no-repeat center center/cover`,
        height: "500px",
        color: "white",
        display: "flex",
        alignItems: "center"
      }}>
        <div className="bg-overlay d-flex align-items-center w-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <h2 className="fw-bold">
                  Where Luxury Meets Seamless Shopping
                </h2>
                <p className="mt-3 text-white">
                  Where AI Meets Intuitive Design – Crafting Seamless Digital Experiences Powered by Intelligence.
                </p>
                <a href="/contact-us/" className="btn btn-custom mt-4">Let’s talk Now!</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <h2 className="h1 fw-bold text-headings mb-4">
                Build Interfaces Users Love & Technology Understands
              </h2>
              <p className="text-secondary mb-3">
                Shopify plugins, often referred to as apps, are third-party integrations that extend the functionality of your Shopify store. Think of them as add-ons that allow you to customize and enhance your online business without needing to write code yourself. These plugins can automate tasks like email marketing, streamline your shipping process, improve customer service with live chat, offer product reviews, and even help with SEO optimization.
              </p>
              <p className="text-secondary mb-4">
                The beauty of Shopify plugins lies in their ease of installation and use. Typically, you can find and install apps directly from the Shopify App Store with just a few clicks. Many offer free plans or trial periods, allowing you to test their features before committing to a paid subscription. Whether you're looking to boost sales, improve customer engagement, or simplify your backend operations, there's likely a Shopify plugin designed to help. By carefully selecting and integrating the right plugins, you can significantly enhance your store's capabilities and drive business growth.
              </p>

              <a href="/contact-us" className="btn btn-white px-4 py-2" style={{
                color: "#1A2B5F",
                border: "0.6px solid #1A2B5F",
                textDecoration: "none" // optional, to remove underline
              }}>
                Let’s Talk About Your Requirements
              </a>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-6">
                  <img src={service_ap} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 1" />
                </div>
                <div className="col-6">
                  <img src={service_ap2} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 2" />
                </div>
                <div className="col-12 pt-4">
                  <img src={service_ap3} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>
            App development Projects
          </h2>
          <div className="row g-4">
            {services.map((service, index) => {
              const isEven = index % 2 === 0;
              const buttonClass = isEven ? 'btn-outline-primary' : 'btn-primary';

              // Define the link based on the service title
              const getServiceLink = (title) => {
                switch (title) {
                  case "Chargam":
                    return "https://play.google.com/store/apps/details?id=com.apps.srashtasoft.chargamleuvapatidar&hl=en_IN";
                  case "Alter Resources":
                    return "https://altercorporation.com/";
                  default:
                    return "/contact-us";
                }
              };

              return (
                <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                  <div className="card h-100 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        <img
                          src={service.icon}
                          loading="lazy"
                          alt={service.title}
                          style={{ width: "80px" }}
                        />
                        <h5 className="card-title ms-3" style={{ marginLeft: "20px" }}>
                          {service.title}
                        </h5>
                      </div>
                      <p className="card-text text-muted">{service.text}</p>
                      {service.topics && (
                        <ul className="list-unstyled mt-3">
                          {service.topics.map((topic, topicIndex) => (
                            <li
                              key={topicIndex}
                              className="mb-2 d-flex align-items-start"
                              style={{ lineHeight: "1.5" }}
                            >
                              <i
                                className="fas fa-check-circle text-primary me-2"
                                style={{ fontSize: "1.1rem", marginTop: "3px" }}
                              ></i>
                              <span style={{ marginLeft: "10px" }}>{topic}</span>
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* Updated Dynamic Button with Link */}
                      <div className="mt-4">
                        <a href={getServiceLink(service.title)} className="text-decoration-none">
                          <button className={`btn ${buttonClass} fw-semibold`}>
                            View More Details

                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>


      {/* Banner CTA */}
      <section className="py-5 text-white position-relative" style={{
        background: `url(${ai_banner2}) no-repeat center center/cover`,
        height: "350px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#007bff40",
          zIndex: 1
        }}></div>

        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start" style={{ position: "relative", zIndex: 2 }}>
          <h2 className="h3 fw-bold mb-4 mb-md-0" style={{ fontSize: "46px" }}>
            Crafting Intelligent Applications with Expert Skill and Advanced Tech
          </h2>
          <a href="/contact-us" className="btn btn-light fw-semibold text-dark" style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "2%",
            width: "180PX",
            height: "56",
            borderRadius: "6px"
          }}>
            Let’s talk Now!
          </a>
        </div>
      </section>

      {/* Services */}

      {/* Industries */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="fw-bold mb-4" style={{ color: "#1A2B5F" }}>Industries We Serve</h2>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-4">
            {industries.map((industry, index) => (
              <div className="col" key={index} style={{
                height: "160px !important",
                marginTop: "24px"
              }}>
                <div className="p-4 shadow-sm h-100 text-center" style={{ borderRadius: "12px", border: "1px solid #E3E3E3" }}>
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    className="mb-3"
                    loading="lazy"
                    style={{ width: "50px", height: "50px", objectFit: "contain" }}
                  />
                  <h5 className="fw-semibold font_size mb-2">{industry.title}</h5>
                  <p className="text-muted small mb-0">{industry.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>apps Development Services</h2>
          <div className="row g-4">
            {products.map((service, index) => (
              <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <img src={service.icon} loading="lazy" className="mb-3" alt={service.title} />
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text text-muted">{service.text}</p>
                    {service.topics && (
                      <ul className="list-unstyled mt-3">
                        {service.topics.map((topic, topicIndex) => (
                          <li key={topicIndex} className="mb-2" style={{
                            display: 'flex',
                            alignItems: 'flex-start'
                          }}>
                            <span dangerouslySetInnerHTML={{ __html: topic }} />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Execution Steps */}
      <section className="bg-primary text-white py-5" style={{
        background: `url(${ai_banner3}) no-repeat center center/cover`,
        height: "660px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundBlendMode: "overlay"
      }}>
        <div className="container text-center" style={{ height: "663px", alignContent: "center" }}>
          <h2 className="fw-bold mb-5" style={{
            fontWeight: 700,
            fontSize: "40px",
            lineHeight: "40px",
            letterSpacing: "2%",
            textAlign: "center",
            textTransform: "capitalize"
          }} >How We Execute Your Project</h2>
          <div className="row justify-content-center gy-4" style={{ height: "313px" }}>
            {executionSteps.map((step, index) => (
              <div className="col-6 col-sm-4 col-md-2" key={index} style={index % 2 !== 0 ? { marginTop: "70px" } : {}}>
                <div className="d-flex flex-column align-items-center">
                  <img
                    src={step.icon}
                    alt={step.text}
                    className="mb-3"
                    style={{ width: "155px", height: "155px", objectFit: "contain" }}
                  />
                  <p className="fw-semibold small text-white mb-0" style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "4%",
                    textAlign: "center",
                    verticalAlign: "middle",
                    textTransform: "capitalize"
                  }}>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-4"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textTransform: "capitalize",
            }}
          >
            FAQs: Application Development Services
          </h2>

          <div className="panel-group wrap" id="bs-collapse">

            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What types of apps do you develop?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>  We develop a wide range of apps, including: </p>
                  <p>Mobile apps (iOS and Android, using native or cross-platform frameworks like Flutter and React Native)</p>
                  <p>Web apps (SaaS platforms, portals, dashboards)</p>
                  <p>Custom business apps (for operations, logistics, CRM, etc.) Our team builds scalable and user-friendly apps tailored to your business goals.</p>

                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    I have an app idea but no technical specifications. Can you help?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Absolutely. We offer discovery and consultation sessions to shape your idea into a clear, actionable plan. Our experts will help define the features, user flow, and tech stack, even if you're starting with just a concept.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What information do I need to provide to get a project estimate?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    To provide an accurate estimate, we generally need:
                  </p>
                  <p> A brief description of the app’s purpose </p>
                  <p> Key features or functionality
                  </p>
                  <p> Target platform (iOS, Android, Web)
                  </p>
                  <p> User roles (admin, users, etc.) </p>
                  <p> Any reference apps or design inspirations Even if you're unsure, our team can guide you step-by-step through the process.</p>

                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do you offer ongoing support?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes. We offer both monthly maintenance plans and on-demand support.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
      <FunfactComponent />
      <section className='need-help-section' id='need-help'>
        <div className='container'>
          <div className='row quote-formss'>
            <div className='col-lg-6 col-md-12'>
              <h1>NEED HELP ?</h1>
              <p className='need-paragraph'>Choosing The Right Package</p>
              <div className='row padding-class'>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={consistent} />
                    </div>
                    <p className='normal-p'>	Contact a <strong class="yello-colors">Webflow WebDevelopment</strong></p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={phonecall} />
                    </div>
                    <p className='normal-p'>	<a classname="ancher-link" href="tel:+(91) 9898582705">Schedule <strong class="yello-colors"> a call with us  </strong></a></p>
                  </div>
                </div>

              </div>
              <span className='heading-text'>+(91) 9898582705</span>
            </div>
            <div className='col-lg-2 col-md-0'></div>
            <div className='col-lg-4 col-md-12'>
              <section id="quote" className="bg-msar msar-quote-form">
                <section className="row">
                  <form onSubmit={sendEmail}>

                    <div className="col-md-12">
                      <div className="mt-4 white-text">Get Your Free</div>
                      <h4 className='white-text'>Consultation &amp; Quote</h4>
                      <div id="frm-quote">
                        <div className="form-group mt-4">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Name*"
                            name="name"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Email*"
                            name="email"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <select class="form-control w-100 border-0 p-2 " name='technology'
                          //  onChange={onInputchange}
                          >
                            <option value="Service">Service Required </option>
                            <option value="ReactJs">ReactJs Development</option>
                            <option value="NodeJs">NodeJs Developement</option>
                            <option value="WordPress">WordPress Development</option>
                            <option value="PHP">PHP Development</option>
                            <option value="Laravel">Laravel Development</option>
                            <option value="Flutter">Flutter Development</option>
                            <option value="Reactnative">React Native Development</option>
                            <option value="Android">Android Development</option>
                            <option value="IOS">IOS Development</option>
                            <option value="graIOTpefruit">IOT Development</option>
                            <option value="UIUX">UI/UX Development</option>
                            <option value="Shopify">Shopify Development</option>
                            <option value="Magento">Magento Development</option>
                            <option value="Layout">Layout Design</option>
                            <option value="Html">Html Development</option>
                            <option value="Logo">Logo Design</option>
                            <option value="Python">Python Development</option>
                          </select>
                        </div>

                        <div className="form-group mb-0">
                          <textarea className="form-group w-100 border-0 p-2 mb-0"
                            rows="2"
                            placeholder="Your Text"
                            // onChange={onInputchange}
                            name="message"
                            required
                          >
                          </textarea>
                        </div>

                        <div className="mt-0 pt-0 small white-text">* Need to fill marked. Make a call more details required.</div>
                        <button type="submit" className="btn-white-custom btn btn-sm mt-3"> Send Message </button>
                      </div>
                    </div>
                  </form>
                </section>
              </section>
            </div>

          </div>
        </div>
      </section>


      <Footer />
    </Layout>
  );
};
export default IotDevelopment;
